import { ExternalLink, Award } from 'lucide-react';
import { GENIUS_LOCI_FINANCING_TEXT, ONERI_PROGRAMS } from '../constants/oneri';

const OneriPubblicitari = () => {
  return (
    <div className="space-y-7 max-w-6xl">
      <div className="space-y-2">
        <h1 className="text-3xl font-bold text-text-primary flex items-center gap-3">
          <Award size={30} className="text-primary" />
          Oneri Pubblicitari
        </h1>
        <p className="text-text-secondary mt-2">
          Obblighi informativi relativi ai finanziamenti pubblici dei progetti Glooci / Genius Loci.
        </p>
      </div>

      <section className="card p-7">
        <h2 className="text-xl font-bold text-text-primary mb-5">Dichiarazione principale</h2>
        <div className="rounded-lg bg-primary/5 border border-primary/20 p-6 text-sm text-text-primary leading-relaxed">
          <p>{GENIUS_LOCI_FINANCING_TEXT}</p>
        </div>
      </section>

      <section className="space-y-5">
        {ONERI_PROGRAMS.map((program) => (
          <article
            id={program.id}
            key={program.id}
            className={`card p-7 border-2 scroll-mt-24 ${program.color}`}
          >
            <div className="flex flex-wrap items-start gap-3 mb-4">
              <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${program.badgeColor}`}>
                {program.sigla}
              </span>
              <a
                href={program.projectUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-xs text-primary hover:underline"
              >
                Scheda progetto <ExternalLink size={12} />
              </a>
            </div>

            <h3 className="text-lg font-semibold text-text-primary mb-2">{program.nome}</h3>
            <p className="text-sm text-text-secondary leading-relaxed mb-4">{program.descrizione}</p>
            <p className="text-sm text-text-primary leading-relaxed mb-5">{program.finanziamento}</p>

            <div className="flex flex-wrap gap-2">
              {program.references.map((reference) => (
                <a
                  key={`${program.id}-${reference.url}`}
                  href={reference.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full border border-border bg-white hover:bg-primary/5"
                >
                  {reference.label}
                  <ExternalLink size={11} />
                </a>
              ))}
            </div>
          </article>
        ))}
      </section>

      <section className="card p-7">
        <h2 className="text-xl font-bold text-text-primary mb-3">Privacy</h2>
        <p className="text-sm text-text-secondary leading-relaxed">
          Informativa privacy: {' '}
          <a
            href="https://www.glooci.it/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >
            www.glooci.it/privacy-policy/
          </a>
        </p>
        <p className="text-xs text-text-secondary/70 mt-3">
          © 2026 Glooci Platform — The Thinking Clouds S.r.l. — Tutti i diritti riservati.
        </p>
      </section>
    </div>
  );
};

export default OneriPubblicitari;
